import { gql } from '@apollo/client';

export const GET_CURRENCY_PRECISIONS = gql`
  query GET_CURRENCY_PRECISIONS {
    getCurrencyPrecisions {
      code
      decimals
    }
  }
`;
